<h2 mat-dialog-title>{{ action === 'edit' ? 'Edit' : 'Create' }} Attestation</h2>
<mat-dialog-content class="mat-typography">
  <div class="container">
    <app-form-builder [formFields]="formFields" [(formGroup)]="userForm"></app-form-builder>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          HTML (Web Portal)
        </ng-template>
        <div class="editor-container">
          <quill-editor
            [(ngModel)]="html"
            [modules]="quillModules"
            [styles]="{ 'min-height': '300px' }"
            placeholder="Enter HTML content for web portal..."
            format="html">
          </quill-editor>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          PDF (Document)
        </ng-template>
        <div class="editor-container">
          <quill-editor
            [(ngModel)]="pdf"
            [modules]="quillModules"
            [styles]="{ 'min-height': '300px' }"
            placeholder="Enter content for PDF document..."
            format="html">
          </quill-editor>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!userForm.valid || submitting">
    {{ submitting ? 'Submitting...' : 'Submit' }}
  </button>
</mat-dialog-actions>